import AsoHeader from "../../../components/Aso/Header";
import AsoCnae from "../../../components/Aso/Register/AsoCnae";

const AsoRegistroCnae = () => {
    return(
        <>
            <AsoHeader />
            <AsoCnae />
        </>
    );
}

export default AsoRegistroCnae;